import { getAccessToken } from './authApi';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || '/api').replace(/\/$/, '');

export async function paymentApi<T>(action: string, options: {
  method?: 'GET' | 'POST';
  body?: Record<string, unknown>;
  id?: string;
  authenticated?: boolean;
} = {}): Promise<T> {
  const method = options.method || 'GET';
  const query = new URLSearchParams({ action });
  if (options.id) query.set('id', options.id);
  const headers: Record<string, string> = { Accept: 'application/json' };
  if (method === 'POST') headers['Content-Type'] = 'application/json';

  if (options.authenticated !== false) {
    const token = getAccessToken();
    if (!token) throw new Error('Sua sessão NutriSync expirou. Entre novamente.');
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}/payments.php?${query.toString()}`, {
    method,
    headers,
    body: method === 'POST' ? JSON.stringify(options.body || {}) : undefined,
    cache: 'no-store',
  });
  const result = await response.json().catch(() => null);
  if (!response.ok || !result?.success) {
    throw new Error(result?.error || 'Não foi possível comunicar com o serviço de pagamentos.');
  }
  return result.data as T;
}

export interface PaymentOrder {
  orderId: string;
  checkoutUrl: string;
}

export interface PaymentOrderStatus {
  id: string;
  plan_key: string;
  amount: number;
  currency: string;
  status: 'creating' | 'pending' | 'approved' | 'rejected' | 'cancelled' | 'refunded' | 'charged_back' | 'error';
  created_at: string;
  approved_at: string | null;
}
